<template>
  <div>
    <div class="columns is-gapless">
      <div class="column">
        <div class="field has-addons">
          <div class="control has-icons-left has-icons-right">
            <input class="input"
              v-model="filter.query"
              type="text"
              placeholder="Start typing to filter"
              @input="search">
            <span class="icon is-left">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
          </div>
          <div class="control">
            <a class="button is-primary is-outlined tooltip"
              data-tooltip="Reset search"
              @click="reset()">
              <span class="icon">
                <i class="mdi mdi-close mdi-24px" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container-avaialble-butterfly-items">
      <bulma-table class="table is-striped is-narrow is-fullwidth"
        :columns="columns"
        :has-sticky-header="true"
        :page-index="filter.pageIndex"
        :page-size="filter.pageSize"
        :total-rows="totalRows"
        :is-loading="isTableLoading"
        :sort-column="filter.sortColumn"
        :sort-order="filter.sortOrder"
        @pageChanged="onPageChange"
        @sort="sort">
        <tr v-for="(item, index) in availableItems"
          :key="index">
          <td>{{ item.itemNo }}</td>
          <td>{{ item.description }}</td>
          <td class="has-text-right"
            @click="addSingleNewItem(item, itemCategoryTypes.MECH, itemCategorySubTypes.FWD, true)">
            <div class="butterfly-item-values is-flex is-justify-content-center"
              :class="[
                { 'has-text-weight-bold is-selected': isSelectedDriveTrainType(item, itemCategoryTypes.MECH, itemCategorySubTypes.FWD) }
              ]">
              {{ $filters.formatNumber(getDisplayValue(itemCategoryTypes.FWD, item.fwdHour), $userInfo.locale) }}
            </div>
          </td>

          <td class="has-text-right"
            @click="addSingleNewItem(item, itemCategoryTypes.MECH, itemCategorySubTypes.RWD, true)">
            <div class="butterfly-item-values is-flex is-justify-content-center"
              :class="[
                { 'has-text-weight-bold is-selected': isSelectedDriveTrainType(item, itemCategoryTypes.MECH, itemCategorySubTypes.RWD) }
              ]">
              {{ $filters.formatNumber(getDisplayValue(itemCategoryTypes.RWD, item.rwdHour), $userInfo.locale) }}
            </div>
          </td>

          <td class="has-text-right"
            @click="addSingleNewItem(item, itemCategoryTypes.MECH, itemCategorySubTypes.AWD, true)">
            <div class="butterfly-item-values is-flex is-justify-content-center"
              :class="[
                { 'has-text-weight-bold is-selected': isSelectedDriveTrainType(item, itemCategoryTypes.MECH, itemCategorySubTypes.AWD) }
              ]">
              {{ $filters.formatNumber(getDisplayValue(itemCategoryTypes.AWD, item.awdHour), $userInfo.locale) }}
            </div>
          </td>

          <td class="has-text-right"
            @click="addSingleNewItem(item, itemCategoryTypes.MECH, itemCategorySubTypes.FourWD, true)">
            <div class="butterfly-item-values is-flex is-justify-content-center"
              :class="[
                { 'has-text-weight-bold is-selected': isSelectedDriveTrainType(item, itemCategoryTypes.MECH, itemCategorySubTypes.FourWD) }
              ]">
              {{ $filters.formatNumber(getDisplayValue(itemCategoryTypes.FourWD, item.fourWDHour), $userInfo.locale) }}
            </div>
          </td>

        </tr>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <span icon="icon is-large">
                <i class="mdi mdi-48px mdi-emoticon-sad" />
              </span>
              <p>Nothing</p>
            </div>
          </section>
        </template>
      </bulma-table>
    </div>
  </div>
</template>

<script>
import QuoteService from '../QuoteService'
import { AvailableOtherLabourNtarColumns } from '../columns'
import { ItemCategoryTypes, ItemCategorySubTypes, QuotingMethodTypes } from '@/enums'
import BulmaTable from '@/components/BulmaTable'
import _debounce from 'lodash.debounce'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import Guid from '@/components/Guid'
// import _isEmpty from 'lodash/isEmpty'
// import HttpStatus from '@/components/http-status'
import StoreMixin from '../storeMixin'
// import _cloneDeep from 'lodash/cloneDeep'
import { QuoteItemModel } from '@/classes/viewmodels'

export default {
  name: 'AvailableOtherLaboursNtar',
  components: {
    BulmaTable
  },
  mixins: [StoreMixin],
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    quoteId: {
      type: String,
      default: ''
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 8
    },
    quotingMethod: {
      type: String,
      default: ''
    },
    fgRate: {
      type: Number,
      default: 0
    },
    crushRate: {
      type: Number,
      default: 0
    },
    cdRate: {
      type: Number,
      default: 0
    },
    mechRate: {
      type: Number,
      default: 0
    },
    shopRate: {
      type: Number,
      default: 0
    },
    isNtar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // innerValue: null,
      selectedRow: null,
      isTableLoading: false,
      totalRows: 0,
      filter: {
        companyId: Guid.empty(),
        query: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: this.pageSize
      },
      availableItems: null,
      selectedItems: [],
      addedItems: []
    }
  },
  computed: {
    columns() {
      return AvailableOtherLabourNtarColumns
    },
    newItems() {
      return this.value.filter((i) => i.isNew && !i.deleted)
    },
    itemCategoryTypes() {
      return ItemCategoryTypes
    },
    itemCategorySubTypes() {
      return ItemCategorySubTypes
    },
    maxAddedItemsLineNumber() {
      return Math.max(...this.addedItems.map((a) => a.lineNumber), 0)
    }
  },
  watch: {},
  async created() {
    // this.innerValue = this.value
    this.filter.companyId = this.$userInfo.companyId
    await this.getAvailableOtherLaboursNtar()
  },
  mounted() {},
  methods: {
    async getAvailableOtherLaboursNtar() {
      this.isTableLoading = true
      this.availableItems = await QuoteService.getAvailableOtherLabourItemsNtar(this.filter)
      this.totalRows = this.availableItems.length > 0 ? this.availableItems[0].totalRows : 0
      this.isTableLoading = false
    },
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.getAvailableOtherLaboursNtar()
    },
    sort(name, order) {},
    reset() {
      this.selectedItems = []
      this.filter.query = ''
      this.filter.pageIndex = 1
      this.getAvailableOtherLabours()
    },
    search: _debounce(function () {
      this.filter.pageIndex = 1
      this.getAvailableOtherLaboursNtar()
    }, 500),
    cancel(value) {
      this.selectedItems = value
    },
    findItem(item, type, subType = null) {
      const existingItem = this.value.find(
        (i) =>
          i.itemDesc === item.description && i.itemNo === item.itemNo && !i.deleted &&
          i.itemType === type && (subType === null || i.itemSubType === subType) &&
          !i.deleteOtherItem
        )
      return existingItem
    },
    isSelectedDriveTrainType(item, type, subType) {
      return !!(this.findItem(item, type, subType))
      // const existingItem = this.findItem(item, type)
      // if (existingItem) {
      //   const hour = this.getDriveTrainHour(item, subType)
      //   const rate = this.isNtar ? this.shopRate : this.mechRate
      //   const isHourMethod = this.quotingMethod === QuotingMethodTypes.Hour
      //   const hourValue = isHourMethod ? hour : roundAwayFromZero(hour * rate)
      //   const found = this.availableItems.find((i) => i.itemNo === item.itemNo && i.description === existingItem.itemDesc)
      //   if (found)
      //     return existingItem.hourValue === hourValue
      // }
      // return false
    },
    getDriveTrainHour(item, subType) {
      switch (subType) {
        case ItemCategorySubTypes.FWD:
          return item.fwdHour
        case ItemCategorySubTypes.RWD:
          return item.rwdHour
        case ItemCategorySubTypes.AWD:
          return item.awdHour
        case ItemCategorySubTypes.FourWD:
          return item.fourWDHour
      }
      return 0
    },
    generateItem(itemNo, description, hourValue, rate, type, subType) {
      let newItem = new QuoteItemModel(this.quoteId, itemNo, description, type, subType)
      newItem.lineNumber = this.nextLineNumber
      newItem.hourValue = this.quotingMethod === QuotingMethodTypes.Hour ? hourValue : roundAwayFromZero(hourValue * rate)
      newItem.rate = rate
      newItem.dollarValue = roundAwayFromZero(hourValue * rate)
      newItem.opgCode = this.vehiclePaintGroup
      newItem.sortNo = this.value.length ? Math.max(...this.value.map((i) => i.sortNo)) + 1 : 1
      return newItem
    },
    addSingleNewItem(item, type, subType, emit = false) {
      const rate = this.isNtar ? this.shopRate : this.mechRate
      const hour = this.getDriveTrainHour(item, subType)
      const existingItem = this.findItem(item, type, subType)

      if (!existingItem) {
        const existingItemOtherSubType = this.findItem(item, type)
        if (existingItemOtherSubType) {
          this.$eventHub.$emit('deleteOtherLabour', existingItemOtherSubType)
        }

        const newItem = this.generateItem(item.itemNo, item.description, hour, rate, type, subType)
        this.addedItems.splice(this.addedItems.length, 1, newItem)
        if (emit) {
          // Delay the emission to avoid race conditions with parent updates
          this.$nextTick(() => {
            this.$emit('item-added', this.addedItems)
            this.addedItems = []
          })
        }

      } else {
        this.$eventHub.$emit('deleteOtherLabour', existingItem)
        // this.$notification.openNotificationWithType('warning', 'Other Labour', `${type} item is already in selected list. Item not added.`)
      }
    },
    // addNewItems(item, index) {
    //   this.addSingleNewItem(item, ItemCategoryTypes.MECH)

    //   if (!_isEmpty(this.addedItems)) {
    //     // const vm = this
    //     // this.addedItems.forEach(function(newItem) {
    //     //   vm.innerValue.splice(vm.innerValue.length, 1, newItem)
    //     // })
    //     this.$emit('item-added', this.addedItems)
    //     this.addedItems = []
    //   }
    // },
    getDisplayValue(type, value) {
      const rate = this.isNtar ? this.shopRate : this.mechRate
      return this.quotingMethod === QuotingMethodTypes.Dollar ? roundAwayFromZero(rate * value) : value
    },
    updateSelectedButterflyCodes(subSections) {
      let selectedCodes = []

      if (subSections && subSections.length > 0) {
        selectedCodes = subSections
          .filter((item) => item.isFilter === true) // Filter based on isFilter property
          .map((item) => item.partId || item.id)
      }

      this.selectedButterflyCodes = selectedCodes
      this.filter.butterflyCode = selectedCodes.join(',')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
